import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { isNil } from '../utils';

@Component({
  selector: 'app-make-enquriy',
  templateUrl: './make-enquriy.component.html',
  styleUrls: ['./make-enquriy.component.scss']
})
export class MakeEnquriyComponent implements OnInit {
  enquiryForm: FormGroup;
  studentName: string;
  phoneNummber: number;
  emailAddress: number;
  venID: string;
  userList:any;
  firstName: string;
  lastName: string;
  parentName: string;
  reqDetails: string;
  age: string;
  encryptEnqID: string;
  category: string;
  pkgID: string;
  courseDetails: any;
  classes: string;
  course_schedule: any;
  batch: string;
  resultArray: any;
  packageList: any;
  courseID: string;
  enquiryID: string;
  vendorID: string;
  partyID: string;
  isSubmitted:string;

  packageMap = {}

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService) {

    this.venID = this.activatedRoute.snapshot.paramMap.get("vendorID");
    this.pkgID = this.activatedRoute.snapshot.paramMap.get("courseID");


    this.enquiryForm = this.formBuilder.group({
      studentName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$'), Validators.pattern(/^\S/)]],
      phoneNummber: ['', [Validators.required, Validators.pattern(/^\d{10,11}$/)]],
      emailAddress: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      parentName: ['', Validators.required],
      age: ['', Validators.required],
      classes: [''],
      courseID: [''],
      scheduleID: [''],
      batch: [''],
      reqDetails: ['']
    });


    
  }


  get selectedClass() {
    return this.enquiryForm.get('courseID');
  }
  get selectedBatch() {
    return this.enquiryForm.get('scheduleID');
  }

  get availableBatches() {
    if (!!this.selectedClass.value && !!this.packageMap[this.selectedClass.value]) {
      return this.packageMap[this.selectedClass.value]
    }
    return [];
  }

  ngOnInit() {

    const userData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      vendorID: this.venID,
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
    }

    this.apiService.hostuserDetails(userData).subscribe((res: any) => {
     
      this.userList = res.data.getUserData.data;
      this.firstName = res.data.getUserData.data.firstName;
      this.lastName = res.data.getUserData.data.lastName;

      this.parentName = !isNil(res.data.getUserData.data.parentName) ? res.data.getUserData.data.parentName : '';
      this.age = res.data.getUserData.data.age;
      this.studentName = this.firstName + " " + this.lastName;
      this.phoneNummber = res.data.getUserData.data.phoneNumber;
      this.emailAddress = res.data.getUserData.data.userEmail;



    }, async err => {

    })

    let businessdata = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),    
      vendorID: this.venID
    }

    this.apiService.businessDetails(businessdata).subscribe((res: any) => {
     
      this.packageList = res.data.vendorBusinessDetails.data.packages;
     
    }, async err => {

    })

    this.selectedClass.valueChanges.subscribe(res => {
      this.selectedBatch.patchValue('')
      this.loadPackageDetails(res)
    })

    if (!isNil(this.pkgID)) {
      this.loadPackageDetails(this.pkgID)
      setTimeout(() => {
        this.selectedClass.patchValue(this.pkgID)
      }, 1000);
    }

  }


  loadPackageDetails(selectedPackageId) {
    let packageData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: selectedPackageId,
      scheduleID: this.venID,
      pkgID: selectedPackageId
    }

    this.apiService.packageDetails(packageData).subscribe((res: any) => {


      this.resultArray = res.data.vendorPkg.data;

      this.courseDetails = res.data.vendorPkg.data.courseDetails;
      

      this.classes = res.data.vendorPkg.data.courseDetails[0].packageName;

      //this.course_schedule = res.data.vendorPkg.data.course_schedule; 

      //this.batch = res.data.vendorPkg.data.course_schedule[0].scheduleID;

      this.packageMap[selectedPackageId] = res.data.vendorPkg.data.course_schedule; 

    })
  }



  saveEnquiry() {

    if (this.studentName == undefined) {
      alert("Please Enter Student Name");
      return;
    }
    else if (this.phoneNummber == undefined) {
      alert("Please Enter Phone Name");
      return;
    }
    else if (this.emailAddress == undefined) {
      alert("Please Enter Phone Name");
      return;
    }
    else if (this.parentName == undefined) {
      alert("Please Enter Phone Name");
      return;
    }
    else if (this.age == undefined) {
      alert("Please Enter Age");
      return;
    }

    else {

      if (this.pkgID == null) {
        
        let packageData = {
          //token: this.helperService.studented_atob(this.helperService.getToken()),
          userID: this.helperService.studented_atob(this.helperService.getUserID()),
          hostID: this.helperService.studented_atob(this.helperService.getHostID()),
          courseID: this.courseID,
          scheduleID: this.venID,
          pkgID: this.courseID
        }

        this.apiService.packageDetails(packageData).subscribe((res: any) => {


          this.resultArray = res.data.vendorPkg.data;
          console.log(this.resultArray);

          this.courseDetails = res.data.vendorPkg.data.courseDetails;
          console.log(this.courseDetails);

          this.classes = res.data.vendorPkg.data.courseDetails[0].packageName;

          //this.course_schedule = res.data.vendorPkg.data.course_schedule; 

          //this.batch = res.data.vendorPkg.data.course_schedule[0].scheduleID;

          const enquiryData = {

            //token: this.helperService.studented_atob(this.helperService.getToken()),
            userID: this.helperService.studented_atob(this.helperService.getUserID()),
              
            course: this.resultArray,
            customerPartyData: { "partyName": this.studentName },
            requirments: this.reqDetails,
            customerData: { requirements: this.reqDetails },
            hostID: this.helperService.studented_atob(this.helperService.getHostID()),   
            vendorID: this.venID,
            scheduleID: this.selectedBatch.value
          }

          this.apiService.createCustomerEnquiry(enquiryData).subscribe((res: any) => {
            this.encryptEnqID = res.data.encryptEnqID;

            this.enquiryID = res.data.enquiryVendorData.data.enquiryId;
            this.vendorID = res.data.enquiryVendorData.data.vendorId;
            this.partyID = res.data.enqueryDataForCustomer.data.partyId;
            alert("Enquiry Details Saved Successfully Enquiry ID  " + this.encryptEnqID);
            this.router.navigateByUrl(`success-enquiry/` + this.enquiryID + `/` + this.partyID + `/` + this.vendorID);

          }, async err => {

          })

        })
      }
      else {
        let packageData = {
          //token: this.helperService.studented_atob(this.helperService.getToken()),
          userID: this.helperService.studented_atob(this.helperService.getUserID()),
          hostID: this.helperService.studented_atob(this.helperService.getHostID()),
          courseID: this.pkgID,
          scheduleID: this.venID,
          pkgID: this.pkgID
        }

        this.apiService.packageDetails(packageData).subscribe((res: any) => {

          this.resultArray = res.data.vendorPkg.data;
         

          this.courseDetails = res.data.vendorPkg.data.courseDetails;
         

          this.classes = res.data.vendorPkg.data.courseDetails[0].packageName;

          //this.course_schedule = res.data.vendorPkg.data.course_schedule; 

          //this.batch = res.data.vendorPkg.data.course_schedule[0].scheduleID;

         
          const enquiryData = {

            //token: this.helperService.studented_atob(this.helperService.getToken()),
            userID: this.helperService.studented_atob(this.helperService.getUserID()),            
            course: this.resultArray,
            customerPartyData: { "partyName": this.studentName },
            requirments: this.reqDetails,
            customerData: { requirements: this.reqDetails },
            hostID: this.helperService.studented_atob(this.helperService.getHostID()),     
            vendorID: this.venID,
            scheduleID: this.selectedBatch.value
          }
          
          this.apiService.createCustomerEnquiry(enquiryData).subscribe((res: any) => {
            this.encryptEnqID = res.data.encryptEnqID;

            this.enquiryID = res.data.enquiryVendorData.data.enquiryId;
            this.vendorID = res.data.enquiryVendorData.data.vendorId;
            this.partyID = res.data.enqueryDataForCustomer.data.partyId;
            alert("Enquiry Details Saved Successfully Enquiry ID  " + this.encryptEnqID);
            this.router.navigateByUrl(`success-enquiry/` + this.enquiryID + `/` + this.partyID + `/` + this.vendorID, {skipLocationChange: true});

          }, async err => {

          })


        })


      }

    }
  }
}

